import CopyAll from "@mui/icons-material/CopyAll";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import MoreVert from "@mui/icons-material/MoreVert";
import Visibility from "@mui/icons-material/Visibility";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

export default function ThreeDotMenu({ options, isCoAppSuperAdmin = false }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<div>
			<IconButton onClick={handleClick} disabled={isCoAppSuperAdmin}>
				<MoreVert
					aria-label="more"
					id="long-button"
					aria-controls={open ? "three-dot-menu" : undefined}
					aria-expanded={open ? "true" : undefined}
					aria-haspopup="true"
				/>
			</IconButton>
			<Menu
				id="three-dot-menu"
				MenuListProps={{
					"aria-labelledby": "long-button",
				}}
				onClose={handleClose}
				onClick={handleClose}
				anchorEl={anchorEl}
				open={open}
			>
				{options.map((option) => (
					<MenuItem key={option.name} onClick={option.optionClickHandler} variant={option.name.includes("Delete") || option.name.includes("Remove") ? "destructive" : "normal"}>
						{option.name.includes("Edit") ? <Edit sx={{ marginRight: "5px", fontSize: "16px" }} /> : null}
						{option.name.includes("Delete") || option.name.includes("Remove") ? <Delete sx={{ marginRight: "5px", fontSize: "16px" }} /> : null}
						{option.name.includes("Duplicate") ? <CopyAll sx={{ marginRight: "5px", fontSize: "16px" }} /> : null}
						{option.name.includes("View") ? <Visibility sx={{ marginRight: "5px", fontSize: "16px" }} /> : null}
						{option.name}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}